import { render, staticRenderFns } from "./CurrentHoldingsTableV2.vue?vue&type=template&id=e584c3a4&scoped=true"
import script from "./CurrentHoldingsTableV2.vue?vue&type=script&lang=ts"
export * from "./CurrentHoldingsTableV2.vue?vue&type=script&lang=ts"
import style0 from "./CurrentHoldingsTableV2.vue?vue&type=style&index=0&id=e584c3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e584c3a4",
  null
  
)

export default component.exports